/** Application-side auth identity keys (never store passwords). */
export const AUTH_TOKEN_KEY = 'token';
export const AUTH_USER_KEY = 'user';
/** Dedicated-workstation optional remembered email only; never used on shared workstations. */
export const REMEMBERED_EMAIL_KEY = 'teks_remembered_email';

export function clearApplicationAuthStorage(): void {
  localStorage.removeItem(AUTH_TOKEN_KEY);
  localStorage.removeItem(AUTH_USER_KEY);
  localStorage.removeItem(REMEMBERED_EMAIL_KEY);
  sessionStorage.removeItem(AUTH_TOKEN_KEY);
  sessionStorage.removeItem(AUTH_USER_KEY);
  sessionStorage.removeItem(REMEMBERED_EMAIL_KEY);
}
